import React from 'react';
import Box from '@mui/material/Box';
import useFreaksT from './useFreaksT';

// Marks computer players so nobody takes a bot for a real freak.
export default function FreaksBotBadge() {
  const { t } = useFreaksT();
  return (
    <Box
      component="span"
      title={t('theFreaks.botA11y')}
      aria-label={t('theFreaks.botA11y')}
      sx={{
        backgroundColor: 'rgba(136,136,136,0.27)', borderRadius: 1, px: 0.6, py: 0.1, ml: 0.75,
        fontSize: 10, fontWeight: 800, flexShrink: 0, color: 'white',
      }}
    >
      🤖 {t('theFreaks.botBadge')}
    </Box>
  );
}
